
// const baseurl = "http://localhost:8000";
const baseurl = "https://api.kalkorom.in";

//-----------------Login
export const loginapi = baseurl + "/adminapp/login/";
//--------Forgot---Password------------------
export const forgotP = baseurl + "/adminapp/password/forgot/";
// -------Otp----Verify--------------z
export const OtpVerify = baseurl + "/adminapp/password/otpverify/";
//------Updates--Password-----e
export const UpdatePassword = baseurl + "/adminapp/password/forgot/";
//------Role--------------------
export const RoleCreate = baseurl + "/adminapp/v2/roles/";
//-----ROle---List-----
export const RoleList = baseurl + "/adminapp/v2/roles/";
//-----roleDelete----
export const RoleDeleteapi = baseurl + "/adminapp/v2/roles/";
//----Role-----Retrieve----
export const RoleRetrieve = baseurl + "/adminapp/v2/roles/";
//-----role-----edits---
export const roleEditsApi = baseurl + "/adminapp/v2/roles/";
//-----------Get Api For Display Table-Data----------------
export const TableData = baseurl + "/admin_app/users/";
//---------------Users-----------
export const Userlist = baseurl + "/adminapp/v1/user/";
//---------------Sheet BulkUpload-----------

export const SheetBulkUploadApi = baseurl + "/reportapp/bulkupload/";
///---------attendacen--dashboard----user_list
export const AttendanceExportUserApi =
  baseurl + "/adminapp/dashboardemployeelist/";

export const UserDelete = baseurl + "/adminapp/v1/user/";
//export const UserCreate = baseurl + "/adminapp/v1/user/";
//---for----the sub---rolls---------
export const UserCreate = baseurl + "/adminapp/agent/";
//---for----the sub---rolls---------
export const employeeExitRequestApi = baseurl + "/adminapp/exitrequest/";
//---for----the sub---rolls---------
export const UserEdit = baseurl + "/adminapp/agent/";
///--user-----
//export const UserEdit = baseurl + "/adminapp/v1/user/";
export const UserRetrieve = baseurl + "/adminapp/v1/user/";

////-----GEo----Loaction
export const GeoState = baseurl + "/geolocation/v1/";
//---state----create
export const stateCretae = baseurl + "/geolocation/v1/";
///----State----Delete
export const StateDeleteApi = baseurl + "/geolocation/v1/";
//---Retrirve---
export const StateRetrieve = baseurl + "/geolocation/v1/";
//----Edit---------
export const StateEdits = baseurl + "/geolocation/v1/";
///----Regions-
export const EmployeeBulkUploadApi = baseurl + "/reportapp/denavebulkoffer/";

export const RegionList = baseurl + "/geolocation/v2/";
export const RegionCreate = baseurl + "/geolocation/v2/";
//----Regions-----Retrieve
export const regionRetriev = baseurl + "/geolocation/v2/";
//---Region---Edits
export const RegionEdit = baseurl + "/geolocation/v2/";
//----region---Delete---
export const RegionDeleteApi = baseurl + "/geolocation/v2/";
//----ZONE---
export const ZONElist = baseurl + "/geolocation/v3/";
//---create
export const Zonecreate = baseurl + "/geolocation/v3/";

//---retrirve
export const ZoneRetrirve = baseurl + "/geolocation/v3/";
//---Zone---Edits
export const ZoneEditsApi = baseurl + "/geolocation/v3/";
//-----Delete
export const ZoneDeleteApi = baseurl + "/geolocation/v3/";
// //----CLient
// export const CLientListAPI = baseurl + "/management/v1/";
// //---client---Create
// export const ClientCreate = baseurl + "/management/v1/";
// //---Clienr-----Edits
// export const ClientEditApi = baseurl + "/management/v1/";
// //---Client----Retrieve
// export const clientRetrieveApi = baseurl + "/management/v1/";
// ///---Client-----Delete
// export const ClientDelete = baseurl + "/management/v1/";
//----CLient
export const CLientListAPI = baseurl + "/adminapp/parent/";
//---client---Create
export const ClientCreate = baseurl + "/adminapp/parent/";
//---Clienr-----Edits
export const ClientEditApi = baseurl + "/adminapp/parent/";
//---Client----Retrieve
export const clientRetrieveApi = baseurl + "/adminapp/parent/";
///---Client-----Delete
export const ClientDelete = baseurl + "/adminapp/parent/";

///-------------Client---Branches
export const ClientBranchListAPi = baseurl + "/management/v2/";
//---Client Branches-----Create---------------
export const ClientBranchCre = baseurl + "/management/v2/";
//---Client---Branches----Delete
export const ClientBranchDel = baseurl + "/management/v2/";
//-----client--------Retrirve
export const clientBranRetrieve = baseurl + "/management/v2/";
///----Client--Branches--------Edits
export const ClientBranEdits = baseurl + "/management/v2/";

///-----Client--Branches----Search
export const ClientSearchAPI = baseurl + "/management/v2/";
///-----------------SHIFT____
export const ShiftCALL = baseurl + "/management/shift/";
///-----Shift---Search-----------
export const SHiftSearch = baseurl + "/management/shift/";
///-----------SHift----Delete
export const ShiftDeleteAPI = baseurl + "/management/shift/";
//-----Shift------Edit
export const ShiftEDITAPI = baseurl + "/management/shift/";
///----Shift-----REtrieve
export const ShiftREtrieve = baseurl + "/management/shift/";
//----Shift---Create
export const ShiftCreateAPI = baseurl + "/management/shift/";
//--shift
export const ShiftSearchAPi = baseurl + "/management/shift";
//----Employee
export const EmployeeApi = baseurl + "/management/inquiry";
//---exployee--Create
export const EmployeeCretaeApi = baseurl + "/management/inquiry/";
//--Employee---Deleet
export const EmployeeDeleteApi = baseurl + "/management/inquiry/";
///---Employee---Edit-----
export const EmployeeEdit = baseurl + "/management/inquiry/";
//---Employee---Retrieve
export const EmployeeRetrieve = baseurl + "/management/inquiry/";
///----Employeee-----Datas-----------------
export const EmployeeDatasApi = baseurl + "/adminapp/client/branchlist/";
///----Employee----Per_---Persons----Lists
export const EmployeeListsPersonsApi =
  baseurl + "/adminapp/client/employeelist/";
///----Employee----Per_---Persons----Lists
export const CasualEmployeeListsPersonsApi =
  baseurl + "/management/casual_employee_list/";
//----Single----Employee---Details
export const EmployeeDetailsAPI = baseurl + "/adminapp/timeline/";

///--------Forms----IDs------------------
export const BasicFormRetrieveApi = baseurl + "/adminapp/boarding/form/v1/";

///----------Address---Form---Api
export const AddressAPi = baseurl + "/adminapp/boarding/form/v2/";

///----IdVerification-----API
export const IdverifyAPI = baseurl + "/adminapp/boarding/form/v3/";

///----Id---verification-----Edit---
export const IdverificationEditApi = baseurl + "/adminapp/boarding/form/v3/";

///-----Bank---Details--------------
export const BankDetailAPI = baseurl + "/adminapp/boarding/form/v4/";
//--EDUCATION-----details--------------
export const EducationDetailsAPI = baseurl + "/adminapp/boarding/form/v5/";

//----Previous---Employee---Details----Api
export const PreviousAPI = baseurl + "/adminapp/boarding/form/v6/";
//--Famil----Details-----Api
export const FamilyAPi = baseurl + "/adminapp/boarding/form/v7/";

//--Decalaration----Details-----Api
export const decalarationApi = baseurl + "/adminapp/boarding/form/v8/";
//--ESi----Details-----Api
export const ESiApi = baseurl + "/adminapp/boarding/form/v9/";
//--Joboffer----Details-----Api
export const JobofferApi = baseurl + "/adminapp/boarding/form/v10/";

////-------------___Export----Form---Approval----APi
export const FormApprovalApi = baseurl + "/adminapp/employee/approved/";
//----Export=-------Completed-------Users----Lists--------------
export const CompletetdUsers = baseurl + "/adminapp/client/approved/employees/";
////--------------------Joining----------------Date------------
export const JoiningDateAPI = baseurl + "/adminapp/employee/joining/";

///----Shift---Excel----Sheet_uploads------------------
export const excelSheetuploads = baseurl + "/adminapp/shifttimeing/";

///---Shfit----Excel---datas------Get--APi
export const ExcelSheetgetApi = baseurl + "/adminapp/shifttimeing/";
///-------Leavetype---create---Api
export const LeaveTypeCreateAPi = baseurl + "/adminapp/leavetype/";
//--Leave---Type---List---------
export const LeaveTypeListAPi = baseurl + "/adminapp/leavetype/";
///---Leave----type---DeleteAPi
export const LeaveTypeDeleteAPi = baseurl + "/adminapp/leavetype/";
///---leave---Type-----Retieve
export const LeaveTypeRetrievAPi = baseurl + "/adminapp/leavetype/";
///--Leave---type---Edits
export const LeavetypeEditApi = baseurl + "/adminapp/leavetype/";

////---Leave----permission---------------
export const LeavePermissionlistAPi = baseurl + "/adminapp/leaves/";
///--Leave---Permission---Delete
export const LeavePermissionDeleteAPi = baseurl + "/adminapp/leaves/";
////--Leave----Permission---Retrieve----
export const LeavePermissionRetrieevApi = baseurl + "/adminapp/leaves/";
///--Leave---Permission---Edits----
export const LeavePermissionEdits = baseurl + "/adminapp/leaves/";
///---DashBoard----
export const Dashboardapi = baseurl + "/adminapp/dashboard/";
//---Employee---_Leave--Status---In CLient Parent View
export const LeaveStatusApi = baseurl + "/adminapp/leaves/";
///---employee----Premission--Shift
export const ShiftPermission = baseurl + "/adminapp/permissions/";
////-------------------employee---shift-----Retrueve
export const ShiftRetrievePermission = baseurl + "/adminapp/permissions/";

////-------------------employee---shift-----Edit
export const ShiftEditPermission = baseurl + "/adminapp/permissions/";
////-------------------employee---shift-----Edit
export const ShiftDeleteAPiPermission = baseurl + "/adminapp/permissions/";
///------Re---Investment---------------
export const ReInvestmentGetApi = baseurl + "/adminapp/reimbursement/";
///------Re---Investment-retrieve--------------
export const ReInvestmentretrievetApi = baseurl + "/adminapp/reimbursement/";
///------Re---Investment--Edit-------------
export const ReInvestmentEditApi = baseurl + "/adminapp/reimbursement/";
////---------On----Duty-----------------
export const OndutyGetlistAPI = baseurl + "/adminapp/onduty/";
////-----Resign------
export const ResginAPI = baseurl + "/adminapp/resign/";
////----Exit------

export const ExitApi = baseurl + "/adminapp/exitflow/";
///--Appraisal---
export const AppraisalApi = baseurl + "/adminapp/appraisal/";
///-----Pay--Slip
export const paySlipApi = baseurl + "/adminapp/payslip/";

///----branch---list--for---a=----field---agent---
export const branchlistfofieldagentapi =
  baseurl + "/adminapp/manager/clientlist/";
////---Employee----list----for----field---agent---after--selected--the---barnch--it diplyathe----employees
export const employeeListforFieldAgentApi =
  baseurl + "/adminapp/manager/employeelist/";
///--------Previous----Data---Call
export const PreviousDataApi = baseurl + "/adminapp/previousform";
///---Data---Fetch----
export const DataFetchApiForForm = baseurl + "/adminapp/datafetch";
////----Grievance--Type=-
export const grievanceApi = baseurl + "/adminapp/grievancetype/";

////----Performance--Type=-
export const performanceApi = baseurl + "/adminapp/growingtype/";
////----PerformanceChild--Type=-
// export const performanceChildApi = baseurl + "/adminapp/performanswer/";
export const performanceChildApi = baseurl + "/adminapp/growingtypechild/";

////---Performs------for---Field--agent---
//export const performFieldAgentAPi = baseurl + "/adminapp/userlist/";

export const performFieldAgentAPi = baseurl + "/adminapp/performuserlist/";

///---Performs-----for---field---agenpmnt-----Data---retrieve
export const performfieldagentRetrievespi = baseurl + "/adminapp/userperform/";
///---sheet----uploads---
export const sheetuploadsApi = baseurl + "/adminapp/excelupload/";
//--create---employee---
export const createEmplosignApi = baseurl + "/adminapp/createemployee/";
///---Grievance-----EMployee---list
export const GrievanceEmployeeListApi = baseurl + "/adminapp/grievance/";

///-----post---for--------man---power----performs---
export const manpowerperformsApi = baseurl + "/adminapp/performanswer/";
///---Particular---Performance-retrieve--for----without----move- the user to next-
export const manpowerperformsretrieveStandApi =
  baseurl + "/adminapp/userperformquestion/";

export const Attendanceexportapi = baseurl + "/adminapp/attendance/export/";

///---Attendance---export =-----get----list-----------
export const AttendanceExportForUserProfilesGetApi =
  baseurl + "/adminapp/attendance/";

///----black---list-
export const blacklistapi = baseurl + "/adminapp/blacklist/";
////---site---transfer---
export const siteTransferapi = baseurl + "/adminapp/transfersite/";
///---send----notifications---
export const setnotificationsapi = baseurl + "/adminapp/sendpushnotification/";
///----pdf----get---list---------
export const pdfgetlistapi = baseurl + "/adminapp/allform/export/";

///---admin--user--list--access--
export const adminuseraccesslist = baseurl + "/adminapp/sidebar/";

///---excel---sheet-------------
export const ExcelSheetGetList = baseurl + "/adminapp/export/form/";
///-------Otp---
export const SignOtpUrl = baseurl + "/adminapp/signotp/send/";
///---signotp ----verify
export const SignOtpVerified = baseurl + "/adminapp/signotp/verify/";
///---Attendance--request------get--list new one
export const AttendaceRequestList = baseurl + "/adminapp/requestattendance/";

////--Attendance----Request---APi a old one
export const AttendanceRequestAPi = baseurl + "/adminapp/emrequestattendance/"; ////---commanded
///---for---overtime---
export const overtimeapi = baseurl + "/adminapp/emrequestattendance/";

///---Active based employee-
export const ActiveBasedEmployees = baseurl + "/adminapp/inactive/";

///---Performance----export---
export const PerformanceExportSheet =
  baseurl + "/adminapp/perform/excelexport/";

export const SuperviorsListPutorRemove =
  baseurl + "/adminapp/supervisor/addremove/";

//---attendance request ---list ---edit api
export const attendanceRequestAPIPutwithmuil =
  baseurl + "/adminapp/requestapproved/";

////---export the baseurl===
export const baseurlforexport = baseurl;

///---Employeee attedance details dashoboard
export const employeedashboard = baseurl + "/adminapp/attendancedashboard/";

export const userdetailsExportApi = baseurl + "/adminapp/userdetails/export/";
///--QUERY----QUESTIONS----
export const QuesyQuestionsApi = baseurl + "/adminapp/trackingparent/";

///---QUERY-----QUESTIONS-----list

export const QuerySubQuestionsApi = baseurl + "/adminapp/trackingcategory/";

///-----help---line----list
export const TrackingrecordAPi = baseurl + "/adminapp/trackingrecord/";

//----finance----api
export const FinancegetApi = baseurl + "/adminapp/financedashboard/";

//---Attendance report dashboard api
export const AttendaceReportApi = baseurl + "/adminapp/attendancedashboard/";

//----Onboarder---details
export const onboarderDetailsApi = baseurl + "/adminapp/timeline/";

///-----passbook_verified--
// export const passbookDatatretrieve =
// "https://project-rainfall-60028348726.development.catalystserverless.in/server/catalyst-zia-services/passbook"; ///---passbook at the end

export const passbookDatatretrieve = baseurl + "/adminapp/bankverify/";

///---id verifycation another api call like kyc employee
// export const idverificationanotherApi = "https://ping.arya.ai/api/v1/kyc";
export const idverificationanotherApi = baseurl + "/adminapp/aadharcardfetch/";
//---send otp for aadhaar card
// export const aadharsendOtpToNumberApi =
//   "https://api.invincibleocean.com/invincible/aadhaarVerification/requestOtp";

export const aadharsendOtpToNumberApi = baseurl + "/adminapp/aadharcard/otp/";

///---Submit----otp
// export const SubmitOTPAADHARVERIFIEDApi =
//   "https://api.invincibleocean.com/invincible/aadhaarVerification/submitOtp";

export const SubmitOTPAADHARVERIFIEDApi =
  baseurl + "/adminapp/aadharcard/verify/";

///----pan---card

// export const Pancardsendotpapi =
//   "https://api.invincibleocean.com/invincible/panPlus";

export const Pancardsendotpapi = baseurl + "/adminapp/pancard/verify/";

///---bank---verified-other--party-api

///--- to ---create token--for penny drop
export const createTokenPennyapi = "https://api.sandbox.co.in/authenticate";
//----to---verifef-----bank
// export const bankPennyDropapi = "https://api.sandbox.co.in/bank/";
export const bankPennyDropapi = baseurl + "/adminapp/bankpennydrop/";

///----report-------sheet---
export const reportgetdatasapi = baseurl + "/reportapp/reports/";

/////-------qpms----EMPLOYEEE----ROLE-----LOGIN
export const udsLoginAPI = baseurl + "/userapp/userlogin/";

//---send---otp
export const UDSEmployeeSentoptapi = baseurl + "/employeeapp/otp/verify/";

export const ShiftDatas = baseurl + "/employeeapp/inout/";
// export const ShiftDatas = baseurl + "/management/inout/qpms/";
export const AttendanceAvaliableLeav = baseurl + "/management/leaves/";
export const AttendanceAvailablePermission =
  baseurl + "/management/permissions/";
export const leaveType = baseurl + "/management/leavetype/get";
export const onDuty = baseurl + "/management/onduty/";
export const calendar = baseurl + "/employeeapp/attendance/";
export const requestCheckInOut = baseurl + "/employeeapp/attendance/";
export const payslip = baseurl + "/management/payslip/";
export const Reimbursement = baseurl + "/management/reimbursement/";
export const RegularizationApis = baseurl + "/management/emrequestattendance/";
export const empResign = baseurl + "/management/resign/";
export const FaceVerificationApi = baseurl + "/employeeapp/face/verification/";
export const GrievanceEmpApi = baseurl + "/management/grievance/";
export const grievenceEmptypegetapi =
  baseurl + "/management/grievancetype/get/";
export const helpdeskGet = baseurl + "/management/trackingrecord/";
export const CateoryForHelpApi = baseurl + "/management/tracking/category/";
export const ParentForHelpApi = baseurl + "/management/tracking/parent/";
export const EmpAttendanceApi = baseurl + "/management/attenuserlist/";
export const sitetransferapi = baseurl + "/management/transfersite/";
export const getBlockListApi = baseurl + "/management/blacklist/";
export const getUnBlockListApi = baseurl + "/management/blackuserlist/";

export const ToclientBranchApi = baseurl + "/management/branchlist/";
export const branchliststrezoapi = baseurl + "/management/client/branchlist/";

export const EmpProfileapi = baseurl + "/management/profile/";
export const EmpNoDueFormFetchapi = baseurl + "/management/noduedatafetch/";
//--no due form
export const NoDueFormEmpAPi = baseurl + "/management/exitflow/";
///---Profile---signature
export const profilesignatureAPI = baseurl + "/adminapp/profile/";

// /--employee--list
export const employeeelistAPi = baseurl + "/adminapp/employeelist/delete/";
export const employeesiteempAPi = baseurl + "/management/userlist/";

export const skillassEmplist = baseurl + "/management/performuserlist/";

export const empstateapi = baseurl + "/management/statelist/";
export const empregionapi = baseurl + "/management/regionlist/";
export const empzonelistapi = baseurl + "/management/zonelist/";
export const emprolelistapi = baseurl + "/management/userroles/";

///---SKILL ASSESSMENT--RETRIEVE---DATAS
export const skillassessmentretrieveapi = baseurl + "/management/userperform/";

export const empquestiongetskillsform =
  baseurl + "/management/userperformquestion/";

export const innerquestionapi = baseurl + "/management/performquestion/";
///--skill assessment--post
export const skillassessmenrcrud = baseurl + "/management/performanswer/";

///---Over---All---report
export const overAllReportget = baseurl + "/adminapp/thirdparty/";

//---filter export
export const overallexportapi = baseurl + "/adminapp/thirdexcel/export/";

//----Over--all-----------report---employee--list
export const overAllEmployeeListAPI = baseurl + "/adminapp/thirdexcel/export/";

///---over---all--report---employee---lis
export const overallemployeelisteAPI = baseurl + "/adminapp/financedashboard/";

///---send---email---
export const sendEmailUpdateApi = baseurl + "/adminapp/reporter/";

///----State ---APi
export const OverallStateAPi = baseurl + "/adminapp/statelist/";

//-----Attendance_location--Api
export const AttendancelocationApi = baseurl + "/adminapp/attendancelocations/";
//-----support  documents---
export const Supportdocumentapi = baseurl + "/adminapp/supportdocument/";
//---my---onboarding-----list
export const MyonoardignApi = baseurl + "/adminapp/onboarduser/";
///---managerrequest---
export const Manager_list_get = baseurl + "/adminapp/managerlist/";

export const PresentUrl = baseurl + "/adminapp/presignedurl/";

//--onboarder----
export const Onboardergetlist = baseurl + "/adminapp/onboarderlist/";
export const RejoningAPi = baseurl + "/adminapp/rejoining/";
//--kyc rejections
export const KysRejectionapi = baseurl + "/adminapp/rejection/";

///--my tickets
export const myTicketApi = baseurl + "/adminapp/myticketlist/";

//---both---the qpms---employee apis
export const BothuserandEmpAPIs = baseurl + "/adminapp/notification/users/";

///--TICKETING SYSTEM
export const ticketcategoryapi = baseurl + "/ticketapp/issue/";

export const ticketsubcategoryapi = baseurl + "/ticketapp/subissue/";
export const ticketlistapi = baseurl + "/ticketapp/ticket/";
export const ticketdashboardapi = baseurl + "/ticketapp/qpmsdashboard/";
// export const ticketdashboardapi = baseurl+"/ticketapp/qpms/dashboard/";

export const udsticketlistapi = baseurl + "/ticketapp/qpmsticketinglist/";
export const ticketremarks = baseurl + "/ticketapp/remarks/";
export const ticketcomment = baseurl + "/ticketapp/comments/";
export const ticketfeedback = baseurl + "/ticketapp/feedback/";
export const ticketlineapi = baseurl + "/ticketapp/tickettimeline/";
export const ticketexports = baseurl + "/ticketapp/qpmsexcelexport/";

export const scopeapi = baseurl + "/ticketapp/scope/";

export const contacteditapi = baseurl + "/ticketapp/clientuser/";

export const categoryscope = baseurl + "/ticketapp/scopeissue/";
export const subcategoryscope = baseurl + "/ticketapp/scopesubissue/";

export const ClientCateEditapi = baseurl + "/ticketapp/clientissue/";

export const ClientCatecreateapi = baseurl + "/ticketapp/clientissue/";

export const neardueapi = baseurl + "/ticketapp/neardue/";

export const departmentissuesapi = baseurl + "/internalticket/departmentissue/";

export const departmentsubissuesapi =
  baseurl + "/internalticket/departmentsubissue/";

export const branchqrapi = baseurl + "/ticketapp/clientqrcode/";
export const unregisertapi = baseurl + "/ticketapp/urticketget/";
export const departmentapi = baseurl + "/internalticket/department/";
export const leveluserapi = baseurl + "/internalticket/departmentuser/";

export const internalTickets = baseurl + "/internalticket/ticket/";
export const internalTicketsget =
  baseurl + "/internalticket/qpmsticketinglist/";
export const internalTicketremarks = baseurl + "/internalticket/remarks/";
export const internalTickettimeline =
  baseurl + "/internalticket/tickettimeline/";
export const internalfeedbackapi = baseurl + "/internalticket/feedback/";
export const internalcommandapi = baseurl + "/internalticket/comments/";

export const DepartmentUsersapi = baseurl + "/internalticket/departmentuser/";

export const InternalDashbaordApi = baseurl + "/internalticket/qpmsdashboard/";
export const InternalNearDueApi = baseurl + "/internalticket/neardue/";
export const rejectassignReassignapi =
  baseurl + "/internalticket/ticketassign/";

export const clientticketview = baseurl + "/internalticket/ticketretrieve/";

export const UnregisterAssign = baseurl + "/ticketapp/ticketassign/";

export const escalationlevelapi = baseurl + "/internalticket/ticketescalarion/";

export const tickethourneyapi = baseurl + "/internalticket/journey/";

export const ticketinernalexport =
  baseurl + "/internalticket/qpmsadvanceexcelexport/";
export const subticketapi =
  baseurl + "/internalticket/assignedudsticketinglist/";

export const clientticketsapi = baseurl + "/ticketapp/clientlist/";
export const clientticketcreateapi = baseurl + "/ticketapp/qpmsclientticket/";
export const clientticketcategoryapi = baseurl + "/ticketapp/clientidissue/";
export const cliensubcategoryapi = baseurl + "/ticketapp/clientsubissuelist/";

export const notifiapilist = baseurl + "/ticket/notification/";

export const dhashboardgraphapi = baseurl + "/adminapp/newdashboard/";

export const subassigneddashboardapi =
  baseurl + "/internalticket/assigneddashboard/";

export const OrganizationAPi = baseurl + "/adminapp/orginationdetails/";

export const advanceattendancecount =
  baseurl + "/adminapp/newattendancedashboard/";
export const advanceattendancetable =
  baseurl + "/adminapp/newattendanceemployeelist/";
export const advanceattendanceState =
  baseurl + "/adminapp/newattendanceemployeecount/";
export const advanceSecondstateapi =
  baseurl + "/adminapp/topattendanceemployeecount/";

export const RmOnboardapi = baseurl + "/adminapp/client/employeelistcount/";

export const internalcategory_dashboardapi =
  baseurl + "/internalticket/ticketcountbycategory/";
export const Customer_department_dashboardapi =
  baseurl + "/ticketapp/externalticketcountbycategory/";
export const InternalStatebasedapi =
  baseurl + "/internalticket/ticketcountbystate/";
export const CustomerSupport_stateApi =
  baseurl + "/ticketapp/externalticketcountbystate/";
export const escalation_internal =
  baseurl + "/internalticket/ticketclosecountbylevel/";
export const escalation_External =
  baseurl + "/ticketapp/externalticketclosecountbylevel/";
export const trendingtickets = baseurl + "/ticketapp/externalticketcountgraph/";
export const categorytopfiveapi =
  baseurl + "/ticketapp/externalticketpercentagebycategory/";
export const custom_card_regionapi =
  baseurl + "/ticketapp/highest_ticketcount/";
export const custom_statechart =
  baseurl + "/ticketapp/externalticketpercentagebystate/";
export const custom_rgionlist =
  baseurl + "/ticketapp/externalticketpercentagebyregion/";
export const custom_zoneApi =
  baseurl + "/ticketapp/externalticketpercentagebyzone/";
export const cusstom_clientapi =
  baseurl + "/ticketapp/externalticketpercentagebyclient/";
export const custom_performancematrix =
  baseurl + "/ticketapp/ticketpercentage/";

/// internal suppports api
export const internal_trendgraphapi =
  baseurl + "/internalticket/internalticketcountgraph/";
export const internal_performancematrix =
  baseurl + "/internalticket/ticketpercentage/";
export const internalLevaleusers =
  baseurl + "/internalticket/ticketclosecountbylevel/";
export const internal_categoryDataapi =
  baseurl + "/internalticket/internalticketpercentagebycategory/";
export const percentangecategoryapi =
  baseurl + "/internalticket/internalticketpercentagebycategory/";
export const internla_ticketHihestapi =
  baseurl + "/internalticket/highest_ticketcount/";
export const internal_supportstate =
  baseurl + "/internalticket/internalticketpercentagebystate/";
export const internal_supportregion =
  baseurl + "/internalticket/internalticketpercentagebyregion/";
export const internal_supportzone =
  baseurl + "/internalticket/internalticketpercentagebyzone/";
export const internal_supportclient =
  baseurl + "/internalticket/internalticketpercentagebyclient/";

export const employee_Editapi = baseurl + "/adminapp/employeelist/delete/";
export const master_dashboard_api = baseurl + "/master/v1/";
export const organization_listapi = baseurl + "/management/v0/";
export const limit_api = baseurl + "/adminapp/limitcheck/";
export const unblock_emp_list = baseurl + "/adminapp/unblock/";
export const exit_request_lisy = baseurl + "/adminapp/exitrequest/";
export const user_client_api = baseurl + "/adminapp/usersclient/";
export const Userlist_client_api = baseurl + "/adminapp/usersclient/";
export const exit_flow_download_api = baseurl + "/adminapp/exit_report/";
export const site_transfer_exports = baseurl + "/adminapp/transfersite_report/";

export const casual_rm_approval_api =
  baseurl + "/management/casual_employee_rm_approval/";
export const casual_onboarding_preview =
  baseurl + "/management/casual_onboarding_preview/";
export const casual_onboarding_update =
  baseurl + "/management/update_casual_employee/";
export const casual_onboarding_delete =
  baseurl + "/management/delete_casual_employee/";

//-----Attendance dashboard v2 (attendance_dashboard app)
export const attendanceDashboardV2 = baseurl + "/attendancedashboard/";
